<footer
  class="border-gray-200 border-t flex items-center custom-footer px-6 text-sm"
>
  Copyright &copy; 2021 <a href="https://funbrew.tech" class="link mx-1"
    >FUNBREW</a
  > All rigths reserved.
</footer>

<style>
  .custom-footer {
    height: var(--custom-footer-height);
  }
</style>
